export default __webpack_public_path__ + "static/media/pet_3.27b4d526.jpg";